/* Cosy mega menu — hover on pointer devices, click everywhere.
   The markup is <details>, so the menu works with this file blocked. */
(function () {
  'use strict';

  const nav = document.querySelector('.cosy-nav');
  if (!nav) return;

  const panels = Array.from(nav.querySelectorAll('[data-cosy-menu]'));
  if (!panels.length) return;

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  let closeTimer = null;

  const closeAll = (except) => {
    panels.forEach((p) => {
      if (p !== except) p.open = false;
    });
  };

  /* one panel at a time, however it was opened */
  panels.forEach((p) => {
    p.addEventListener('toggle', () => {
      if (p.open) closeAll(p);
    });
  });

  if (canHover) {
    panels.forEach((panel) => {
      panel.addEventListener('pointerenter', () => {
        window.clearTimeout(closeTimer);
        panel.open = true;
      });
    });

    /* leaving the whole bar closes, with a grace period so a diagonal mouse
       path from the trigger down into the panel does not shut it */
    nav.addEventListener('pointerleave', () => {
      closeTimer = window.setTimeout(() => closeAll(null), 180);
    });

    nav.addEventListener('pointerenter', () => window.clearTimeout(closeTimer));
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = panels.find((p) => p.open);
    if (!open) return;
    open.open = false;
    const summary = open.querySelector('summary');
    if (summary) summary.focus();
  });

  document.addEventListener('click', (event) => {
    if (!nav.contains(event.target)) closeAll(null);
  });

  /* keyboard: tabbing out of a panel closes it */
  nav.addEventListener('focusout', (event) => {
    if (!nav.contains(event.relatedTarget)) closeAll(null);
  });
})();
